import { Flex, Text } from "@mantine/core";

import { TableEmptyValue } from "../../components/Table/constants.tsx";
import { DeskCollectionLog } from "../../graphql/generated.ts";
import { toLocalDate } from "../../utils/date.ts";
import { getUserDisplayName } from "../../utils/user.ts";

interface Props {
  logs: DeskCollectionLog[] | null | undefined;
}

export const DeskCollectionLogs = ({ logs }: Props) => {
  const lastLog = logs?.length ? logs[logs.length - 1] : null;

  if (!lastLog) {
    return <Text>{TableEmptyValue}</Text>;
  }

  return (
    <Flex direction="column">
      <Flex gap={5}>
        <Text weight={600}>Latest Sent Date:</Text>
        <Text>{toLocalDate(lastLog.createdAt)}</Text>
      </Flex>
      <Flex gap={5}>
        <Text weight={600}>Total Sent Messages:</Text>
        <Text>{logs?.length ?? 0}</Text>
      </Flex>
      <Flex gap={5}>
        <Text weight={600}>Last Sender:</Text>
        <Text>{getUserDisplayName(lastLog.user)}</Text>
      </Flex>
    </Flex>
  );
};
